module.exports = __webpack_public_path__ + "static/media/replayer_tv_icon.19405d88.svg";